export const FREQUENCY_CODE = {
	P1M: 'Monthly',
	P3M: 'Quarterly',
	P12M: 'Yearly'
}

export const FREQUENCY_API_CODE = {
	P1M: 'P1M',
	P3M: 'P3M',
	P12M: 'P12M'
}

export const FREQUENCY_PRICE = {
	Monthly: 'price',
	Quarterly: 'quarterlyPrice',
	Yearly: 'yearlyPrice'
}

export const PERIOD_CODE = {
	P6M: 'P6M',
	P1Y: 'P1Y',
	P2Y: 'P2Y',
	P3Y: 'P3Y',
	P4Y: 'P4Y',
	P5Y: 'P5Y',
	P12M: 'P12M',
	P24M: 'P24M',
}

export const TRANSLATE_PERIOD = {
	P6M: '6 months',
	P1Y: '12 Months',
	P2Y: '24 Months',
	P3Y: '36 Months',
	P4Y: '48 Months',
	P5Y: '60 Months',
	P12M: '12 Months',
	P24M: '24 Months',
}

export const SUBSCRIPTION_STATUS = {
	A: "ACTIVE",
	I: "INACTIVE",
	CANCELLED: "CANCELLED",
	FOR_CANCELLATION: "FOR_CANCELLATION",
	ENDED: "ENDED",
    DISAPPROVED_CANCELLATION: "DISAPPROVED_CANCELLATION",
    APPROVED_CANCELLATION: "APPROVED_CANCELLATION",
	DELETED: "DELETED",
}